import ReactDOM from 'react-dom'
import App from "apps/web_forms";

ReactDOM.render(<App />, document.querySelector('#root'))